export enum CmsCollectionSchemaDataRefTypeEnum {
  OneToOne = 1,
  OneToMany = 2,
}
